import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';

export const getProjectFirestopDocumentationData = async (projectId) => {
  const apiPath = `firestop-documentation/project/${projectId}/firestop-documentation-data`;

  const signedRequest = await createSignedGetRequest({
    apiPath,
  });

  const response = await axios(signedRequest);

  return response.data;
};
